import { AddDiscussionComponent } from './../warr-detail-management/dialog/add-discussion/add-discussion.component';
import { ImportTicket } from 'src/app/model/import-ticket/import-ticket';
import { Toaster } from "@abp/ng.theme.shared";

/**
 * WARR Constants
 */
export class Constants {
  // Style constants
  public static ModalSizeWidth = {
    PopupWidth: "500px", // For confirmation popup
    SmallWidth: "600px",
    MediumWidth: "800px",
    LargeWidth: "1000px",
    FullWidth: "90%",
  }
  public static ImportTicketStatus = {
    Open: "Open",
    Part_Received: "Part_Received",
    Received: "Received",
    Cancelled: "Cancelled",
    RequestCancel: "RequestCancel",
    ConsignmentRequest: "ConsignmentRequest",
    Consigned: "Consigned",
    Shipped: "Shipped"
  }

  public static InventoryMovementTypeConsts = {
    Consignment: "Consignment"
  }
  //
  //
  public static ResultStatus = {
    Success: 'Success',
    Error: 'Error',
    ValidationFailed: 'ValidationFailed',
    NotExist: 'NotExist',
    NotFound: 'NotFound'
  }

  public static AddDiscussionConsts = {
    SolvedReturn: 'SolvedReturn',
    WarrDiscussion: 'WarrDiscussion'
  }

  public static Status = {
    Active: 'ActiveStatus_Active',
    InActive: 'ActiveStatus_Inactive'
  }

  public static CommonGroupCodeForDefinition = {
    WarrReason: 'WarrReason',
    WarrSolution: 'WarrSolution',
    WarrDiagnose: 'WarrDiagnose',
    WarrErrorClassify: 'WarrErrorClassify',
    WarrErrorCause: 'WarrErrorCause',
    WarrReasonClassify: 'WarrReasonClassify',
    WarrSolutionClassify: 'WarrSolutionClassify'
  }

  public static CountryCode = "VN";
  public static DiscussionClassifyWarranty = "DiscussionClassify_Warranty";
  public static DiscussionChannelCustomer = "DiscussionChannel_Customer";

  public static ToasterConfig: Partial<Toaster.ToastOptions> = {
    life: 2000,
  };

  public static ToasterConfigLong: Partial<Toaster.ToastOptions> = {
    life: 5000,
  };

  public static phoneRegex: string = "([0-9]{10})|([0-9]{12})";// "(01|02|03|04|06|07|08|09|05|01[2|6|8|9])+([0-9]{8})|(01|02|03|04|06|07|08|09|05|01[2|6|8|9])+([0-9]{10})";

  public static emailRegex: string = "[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}";

  public static warrType = {
    warrTypeHome: "WarrType_Customer_Home",
    warrTypeCenter: "WarrType_Center",
    warrTypeCasper: "WarrType_Casper"
  }
  public static latLongRegex: string = '([0-9.]{2,3})+([0-9]{1,7})';

  public static DiscussionClassify = {
    Inbound: 'DiscussionClassify_Inbound',
    Outbound: 'DiscussionClassify_Outbound'
  }

  public static CommonGroupCode = {
    WarrReason: 'WarrReason',
    WarrSolution: 'WarrSolution',
    WarrDiagnose: 'WarrDiagnose',
    WarrErrorClassify: 'WarrErrorClassify',
    WarrErrorCause: 'WarrErrorCause',
    WarrReasonClassify: 'WarrReasonClassify',
    WarrSolutionClassify: 'WarrSolutionClassify',
    WarrType: 'WarrType',
    WarrClassify: 'WarrClassify',
    WarrMethod: 'WarrMethod',
    WarrCostType: 'WarrCostType',
    ServiceCenterType: 'ServiceCenterType',
    ServiceCenterRank: 'ServiceCenterRank',
    AccessoryClassify: 'AccessoryClassify',
    ActiveStatus: 'ActiveStatus',
    PICType: 'PICType',
    JobType: 'JobType',
    WarrCostStatus: 'WarrCostStatus',
    Priority: 'Priority',
    ContactChannel: 'ContactChannel',
    InformChannel: 'InformChannel',
    DiscussionChannel: 'DiscussionChannel',
    DiscussionClassify: 'DiscussionClassify',
    AccsStatus: 'AccsStatus',
    WarrStatus: 'WarrStatus',
    TrackingAction: 'TrackingAction',
    TicketStatus: 'TicketStatus',
    ExportTicketStatus: 'ExportTicketStatus',
    ExportTicketType: 'ExportTicketType',
    'NoUseAccessoryReason': 'NoUseAccessoryReason',

  }

  public static DateFormat: any = {
    ControlInput: 'YYYY-MM-DDTHH:mm',
    ControlInputSort: 'YYYY-MM-DD',
    ShortDateTime: 'DD/MM HH:mm',
    ShortTime: 'HH:mm',
    Default: 'DD/MM/yyyy HH:mm',
    DateDMY: 'DD/MM/YYYY',
    DateMY: 'MM/YYYY',
    DateTimeDMY: 'DD/MM/YYYY HH:mm:ss',
    DateCompare: 'yyyyMMdd'
  };

  /**
   * Return empty guid
   */
  public static GuidEmpty: string = '00000000-0000-0000-0000-000000000000';

  public static EmpRole = {
    admin: 'admin',
    technician: 'technician'
  }

  public static WarrantyStatus = {
    WaitingForConfirm: 'WarrStatus_WaitingForConfirm',
    SCConfirmed: 'WarrStatus_SCConfirmed',
    Assigned: 'WarrStatus_Assigned',
    Contacted: 'WarrStatus_Contacted',
    Checked: 'WarrStatus_Checked',
    AccessoryOrder: 'WarrStatus_AccessoryOrder',
    AccessoryReOrder: 'WarrStatus_AccessoryReOrder',
    WaitingForCancel: 'WarrStatus_WaitingForCancel',
    Cancelled: 'WarrStatus_Cancelled',
    Completed: 'WarrStatus_Completed',
    Solved: 'WarrStatus_Solved',
    IntransitToCasper: 'WarrStatus_IntransitToCasper',
    RecievedByCasper: 'WarrStatus_RecievedByCasper',
    RecievedBySC: 'WarrStatus_RecievedBySC',
    IntransitToSC: 'WarrStatus_IntransitToSC'
  }

  public static WarrantyStatusColor = {
    WarrStatus_WaitingForConfirm: '#118DFF',
    WarrStatus_SCConfirmed: '#0F52BA',
    WarrStatus_Assigned: '#9370DB',
    WarrStatus_Contacted: '#118DFF',
    WarrStatus_Checked: '#FF5733',
    WarrStatus_AccessoryOrder: '#FF7F50',
    WarrStatus_AccessoryReOrder: '#8B4513',
    WarrStatus_WaitingForCancel: '#DE6A73',
    WarrStatus_Cancelled: '#DC143C',
    WarrStatus_Completed: '#2E8B57',
    WarrStatus_IntransitToCasper: '#9ACD32',
    WarrStatus_RecievedByCasper: '#808000',
    WarrStatus_RecievedBySC: '#008080',
    WarrStatus_IntransitToSC: '#20B2AA'
  }

  public static WarrantyCostStatusColor = {
    WarrCostStatus_Inprogress: '#118DFF',
    WarrCostStatus_WaitingForProgress: '#9370DB',
    WarrCostStatus_Completed: '#2E8B57',
    WarrStatus_IntransitToCasper: '#9ACD32',
  }

  public static AccessoryRequestStatusEnum = {
    New: 'New',
    Accepted: 'Accepted',
    Packed: 'Packed',
    Deliveried: 'Deliveried',
    Received: 'Received',
    Used: 'Used',
    Export: 'Export',
    Returned: 'Returned',
    Cancelled: 'Cancelled'
  }

  public static ReceiveEquipmentRequestEnum = {
    AccsStatus_New: 'AccsStatus_New',
    AccsStatus_Accepted: 'AccsStatus_Accepted'
  }

  public static AccessoryDeliverStatusEnum = {
    AccsStatus_Accepted: 'AccsStatus_Accepted',
    AccsStatus_Packed: 'AccsStatus_Packed',
    AccsStatus_WarehouseSelected: 'AccsStatus_WarehouseSelected'
  }

  public static CostTypeDelivery = ["WarrCostType_Hang_Muc_Van_Chuyen", "WarrCostType_Hang_Muc_Di_Chuyen"];

  public static CostTypeDeliveryEnum = {
    Movement: "WarrCostType_Hang_Muc_Di_Chuyen",
    Transportation: "WarrCostType_Hang_Muc_Van_Chuyen"
  }

  public static timeBlockUI = 800;

  public static WarrMethod = {
    Service: 'WarrMethod_Dich_Vu',
    Insurance: 'WarrMethod_Bao_Hanh'
  }

  public static TrackingTypeEnum = {
    Status: 'TrackingType_Status',
    Action: 'TrackingType_Action'
  }

  public static TrackingSourceEnum = {
    Warranty: 'Warranty',
    AccessoryRequest: 'AccessoryRequest'
  }

  public static NotificationTypeEnum = {
    Warranty: 'Warranty',
    AccessoryRequest: 'AccessoryRequest'
  }

  public static MaterialType = {
    Machine: 'Machine',
    Part: 'Part'
  }

  //Maximum size of a file upload: 2MB
  public static MaxSizeFileUpload = 2097152;
  public static MaxSizeVideoUpload = 31457280;


  public static PriorityType = {
    Hight: 'Priority_Hight',
    Low: 'Priority_Low',
    Medium: 'Priority_Medium'
  }

  public static CenterType = {
    Casper: 'ServiceCenterType_Casper',
    Service: 'ServiceCenterType_Service_Center'
  }

  public static WarrClassifyType = {
    New: "WarrClassify_New_Error",
    Old: "WarrClassify_Old_Error",
  }

  public static LocalKey = {
    ServiceCenterCode: 'serviceCenterCode',
    ServiceCenterName: 'serviceCenterName',
    RoleName: 'roleName',
    employeeId: 'employeeId',
    EmployeeName: 'employeeName',
    GoogleApiKey: 'googleApiKey',
    IsCasperEmployee: 'isCasperEmployee',
    RoleId: 'roleId',
    CurrentRoles: 'CurrentRoles',
  }

  public static WareHouseType =
    {
      Export: "Export",
      Import: "Import",
      Both: "Both",
    }

  public static NoUseAccessoryReason = {
    // Đặt nhầm
    Misplaced: "Reason_Misplaced",
    // Linh kiện bị lỗi
    ErrorAccessory: "Reason_ErrorAccessory",
    // Khách hàng từ chối thay thế
    CustomerRefused: "Reason_CustomerRefused",
  }

  public static AccessoryStatus = {
    // khi nhân viên tạo và bấm gửi yêu cầu.
    New: "AccsStatus_New",
    // nhân viên admin tiến hành chia kho
    Accepted: "AccsStatus_Accepted",
    // nhân viên kho xác nhận đóng gói
    Packed: "AccsStatus_Packed",
    // khi thủ kho xác xác nhận giao linh kiện.
    Delivered: "AccsStatus_Delivered",
    // Xác nhận đã nhận linh kiện
    Received: "AccsStatus_Received",
    // Xác nhận Sử dụng
    Used: "AccsStatus_Used",
    // Xác nhận không sử dụng
    NoUse: "AccsStatus_NoUse",
    // Xác nhận Xuất kho (Đồng bộ SAP thành công)
    Exported: "AccsStatus_Exported",
    // Xác nhận Trả về kho
    Returned: "AccsStatus_Returned",
    // Trường hợp vừa tạo yêu cầu linh kiện, KTV hủy phiếu YCLK
    Cancelled: "AccsStatus_Cancelled",
    // Đã chọn kho
    WarehouseSelected: "AccsStatus_WarehouseSelected",
    // Kiểm tra lại
    AccsStatus_RecheckSerial: "AccsStatus_RecheckSerial",
    // Sai serial
    AccsStatus_WrongSerial: "AccsStatus_WrongSerial",
    // Yêu cầu ký gửi
    ConsignmentRequest: "AccsStatus_ConsignmentRequest",
    /// Đã ký gửi
    Consigned: "AccsStatus_Consigned",
    /// Yêu cầu nhập kho
    ReceiptRequestCreated: "AccsStatus_ReceiptRequestCreated",
  }
  public static RecallConfirmedStatus = {
    Confirmed: 'AccsRecallStatus_Confirmed',
    WaitingForConfirm: 'RecallStatus_WaitingForConfirm',
    WaitingForExplain: 'AccsRecallStatus_WaitingForExplain',
  }
  public static RecallConfirmedStatusEnum = {
    AccsRecallStatus_Confirmed: 'AccsRecallStatus_Confirmed',
    AccsRecallStatus_WaitingForExplain: 'AccsRecallStatus_WaitingForExplain',
  }

  public static RecallStatus = {
    true: 'RecallStatus_Confirmed',
    false: 'RecallStatus_WaitingForConfirm'
  }
  public static PageUrl = {
    WarrantySearch: "/warranty/search",
    WarrantyCreate: "/warranty/create",
    WarrantyClone: "/warranty/clone",
    WarrantyDetail: "/warranty/detail",
    AccessorySearch: "/accessory/search",
    WarrantyCompleted: "/warranty/complete",
    AccessoryReceive: "/accessory/receive",
    AccessoryDetailSelectWarehouse: "/accessory/warehouse",
    AccessoryRequestViewDetail: "/accessory/detail",
    ServiceCenter: "/category/service-center",
    EmployeeList: "/employee/list",
    EmployeeRole: "/employee/role",
    ServiceCenterDetail: "/category/service-center/detail",
    WarrantyCost: "/warranty/cost",
    WarrantyCostDetail: "/warranty/cost/detail",
    CreateImportTicket: "/service-center/import-ticket",
    CreateExportTicket: "/service-center/export-ticket",
    ExportTicketDetail: "/service-center/export-ticket/detail"
  }

  public static SerialApiUrl = {
    Received: "serial-received",
    Recheck: "serial-recheck",
  }

  public static ReferenceType = {
    TrackingSource_Warranty: "TrackingSource_Warranty",
    TrackingSource_AccessoryRequest: "TrackingSource_AccessoryRequest"
  }
  public static TrackingActionReference = {
    TrackingAction_AS: "TrackingAction_AS",
    TrackingAction_Warr: "TrackingAction_Warr"
  }

  public static AccessoryDeliverStatus: any[] = [
    {
      itemCode: "AccsStatus_Accepted",
      itemName: "Đã Tiếp Nhận"
    },
    {
      itemCode: "AccsStatus_Packed",
      itemName: "Đã Đóng Kiện"
    }
  ]

  public static PicTypeCode =
    {
      CpAdmin: 'PICType_Casper_Admin',
      ScAdmin: 'PICType_Service_Center_Admin',
      ScTechnician: 'PICType_Service_Center_Technician',
      CpTechnician: 'PICType_Casper_Technician',
      StockKeeper: 'PICType_Stockkeeper'
    }

  public static WarrCostStatusCode = {
    WaitingForProgress: 'WarrCostStatus_WaitingForProgress',
    Inprogress: 'WarrCostStatus_Inprogress'

  }

  public static WarrantyCostStatusCode = {
    WarrCost_NotUpdated: 'WarrCost_NotUpdated',
    WarrCost_Pending: 'WarrCost_Pending',
    WarrCost_Approved: 'WarrCost_Approved',
    WarrCost_Rejected: 'WarrCost_Rejected'
  }

  public static WarrantyCostStatusType = {
    WarrCostType_Hang_Muc_Di_Chuyen: 'WarrCostType_Hang_Muc_Di_Chuyen',
    WarrCostType_Hang_Muc_Van_Chuyen: 'WarrCostType_Hang_Muc_Van_Chuyen',
    WarrCostType_Phi_Xu_Ly_Su_Co: 'WarrCostType_Phi_Xu_Ly_Su_Co',
    WarrCostType_Phi_Vat_Tu: 'WarrCostType_Phi_Vat_Tu',
    WarrCostType_Phi_Khac: 'WarrCostType_Phi_Khac'

  }

  public static RecallIsMachine = {
    true: '1',
    false: '0'
  }

  public static AccessoryRecallClassifyEnum = {
    AccesoryClassifyA: 'AccesoryClassify_A',
    AccesoryClassifyB: 'AccesoryClassify_B',
    AccesoryClassifyC: 'AccesoryClassify_C'
  }

  public static MaxResultCount: number = 30;

  public static MaxResultCountWarr: number = 100;

  public static MinDateReport: Date = new Date(2021, 10, 1);

  public static DCCustomerCare: string = 'DiscussionChannel_Customer_Care';

  public static MY_DATE_FORMAT = {
    parse: {
      dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
    },
    display: {
      dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
      monthYearLabel: 'MMMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY'
    }
  };

  public static MY_DATE_MONTH_FORMAT = {
    parse: {
      dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
    },
    display: {
      dateInput: 'MM/YYYY', // this is how your date will get displayed on the Input
      monthYearLabel: 'MMMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY'
    }
  };
}

export enum RESULT_STATUS_ENUM {
  SUCCESS = 'Success',
  ERROR = 'Error',
  VALIDATIONFAILED = 'ValidationFailed'
}

export enum HR_PERMISSION_ENUM {
  // - View on web" permisson, which combines with below default permissions to show exact Menu.
  // - For example, HR.ViewOnWeb let system know that you have permission to access any menu, and
  // which menu to show, depending on default permission below: HR.Employees, or something else.
  HR_VIEW = 'HR.ViewOnWeb',

  // View Employees list UI
  EMPLOYEES = 'HR.Employees',
  EMPLOYEES_CREATE = 'HR.Employees.Create',
  EMPLOYEES_EDIT = 'HR.Employees.Edit'
}

export enum HR_CONSTANTS {
  EMPTY_GUID = '00000000-0000-0000-0000-000000000000',
  SELECTION_ALL = 'ALL',
  ADMIN_ROLE_NAME = 'admin',
}

export enum HR_WORKING_STATUS {
  ACTIVE = 'WSActive',
  INACTIVE = 'WSInactive',
}

export enum MDM_COUNTRY_PROVINCE_TYPE_ENUM {
  COUNTRY = 'COUNTRY',
  PROVINCE = 'PROVINCE',
  DISTRICT = 'DISTRICT',
  WARD = 'WARD'
}

export enum WARR_SERVICE_CENTER_STATUS {
  ACTIVE = 'ActiveStatus_Active',
  INACTIVE = 'ActiveStatus_Inactive'
}

export enum PageUrl {
  Search = '/employee-management',
  Create = '/employee-management/create',
  Detail = '/employee-management/detail'
}

